// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBe1WdEmCx9Y8HSO8OHAOyaqJWDwZsGf8E",
  authDomain: "quiz-app-hil.firebaseapp.com",
  projectId: "quiz-app-hil",
  storageBucket: "quiz-app-hil.appspot.com",
  messagingSenderId: "410853086291",
  appId: "1:410853086291:web:79cabae95926306c0922a6",
  measurementId: "G-Q30Q4RE6F4",
};

// Initialize Firebase
const fb = initializeApp(firebaseConfig);

// initialize Firestore and Auth
export const auth = getAuth(fb);
export const db = getFirestore(fb);
export default fb;
